import React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";

import RbActions from "components/RbActions";
import RbButtonAction from "components/RbButtonAction";
import RbFlexView from "components/RbFlexView";
import RbFlexViewItem from "components/RbFlexViewItem";
import RbHeader from "components/RbHeader";
import RbScrollView from "components/RbScrollView";
import RbSwipeView from "components/RbSwipeView";
import RbSwipeViewItem from "components/RbSwipeViewItem";

import ProductsContent from "../ProductsContent";
import ProductsFilter from "../ProductsFilter";
import ProductsSearchParams from "../ProductsSearchParams";

function ProductsMobile(props) {
  const { filters, onFilter, onSearch, searchParams } = props;

  const history = useHistory();
  const { pathname } = useLocation();

  const [activeTab, setActiveTab] = React.useState(1);
  const [modalOpen, setDialogOpen] = React.useState(false);

  const handleNew = React.useCallback(() => {
    history.push(`${pathname}/new`);
  }, [history, pathname]);

  const handleChangeTab = React.useCallback((_, index) => {
    setActiveTab(index);
  }, []);

  const handleOpen = React.useCallback(() => {
    setDialogOpen(true);
  }, []);

  const handleClose = React.useCallback(() => {
    setDialogOpen(false);
  }, []);

  const handleSearch = React.useCallback(
    (params) => {
      onSearch(params);
      setDialogOpen(false);
    },
    [onSearch]
  );

  return (
    <>
      <RbFlexView>
        <RbFlexViewItem>
          <RbHeader
            title="Products"
            actions={
              <RbActions compacted>
                <RbButtonAction
                  Icon={SearchIcon}
                  onClick={handleOpen}
                  text="Search"
                />
                <RbButtonAction Icon={AddIcon} onClick={handleNew} text="New" />
              </RbActions>
            }
          >
            <Tabs
              indicatorColor="primary"
              textColor="primary"
              aria-label="disabled tabs example"
              value={activeTab}
              variant="fullWidth"
              scrollButtons="off"
              onChange={handleChangeTab}
            >
              <Tab label="Filter" />
              <Tab label="Result" />
            </Tabs>
          </RbHeader>
        </RbFlexViewItem>
        <RbFlexViewItem
          flex="1"
          bgcolor="custom.bg.100"
          borderTop={1}
          borderColor="custom.border.200"
        >
          <RbSwipeView activeView={activeTab} onChange={handleChangeTab}>
            <RbSwipeViewItem>
              <RbScrollView>
                <ProductsFilter onFilter={onFilter} filters={filters} />
              </RbScrollView>
            </RbSwipeViewItem>
            <RbSwipeViewItem>
              <RbScrollView pb={5} pt={2}>
                <ProductsContent
                  filters={filters}
                  searchParams={searchParams}
                />
              </RbScrollView>
            </RbSwipeViewItem>
          </RbSwipeView>
        </RbFlexViewItem>
      </RbFlexView>
      <Dialog open={modalOpen} onClose={handleClose} keepMounted>
        <DialogContent>
          <ProductsSearchParams onSearch={handleSearch} />
        </DialogContent>
      </Dialog>
    </>
  );
}

ProductsMobile.propTypes = {
  filters: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default React.memo(ProductsMobile);
